const bannerCarousel = document.getElementById("homepage-banner-carousel");
const isAutoplay = bannerCarousel.dataset.autoplay === "autoplay";
const autoplayDelay = parseInt(bannerCarousel.dataset.autoplayDelay, 10) || 5000;

new Swiper("#homepage-banner-carousel", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 1,

  autoplay: isAutoplay
    ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      }
    : false,

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
